import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../lib/AuthContext';
import './Dashboard.css';
import orangeLogo from '../assets/orangelog.png';

const US_STATES = [
  'AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA','HI','ID','IL','IN','IA',
  'KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ',
  'NM','NY','NC','ND','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VT',
  'VA','WA','WV','WI','WY','DC',
];

const BLANK = {
  username: '', company_name: '', email: '', password: '',
  subscription_tier: 'base', mediaType: 'news',
  contact_phone: '', contact_email: '', contact_address: '',
  city: '', state: '', zipcode: '', isLocalOnly: false,
  admin_password: '',
};

export default function AdminAddCompany() {
  const navigate = useNavigate();
  const { accessToken: token, clearSession } = useAuth();
  const isAdmin = localStorage.getItem('isAdmin') === 'true';

  const [form, setForm]       = useState(BLANK);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');
  const [created, setCreated] = useState(null); // success result

  useEffect(() => {
    if (!token || !isAdmin) navigate('/login');
  }, [token, isAdmin, navigate]);

  const handleLogout = () => { clearSession(); navigate('/login'); };

  const set = (field, val) => setForm(f => ({ ...f, [field]: val }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res = await axios.post('/api/admin/companies', form, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCreated(res.data);
      setForm(BLANK);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to create company.');
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: '100%', padding: '0.5rem 0.75rem',
    border: '1px solid #ccc', borderRadius: '6px',
    fontSize: '0.9rem', boxSizing: 'border-box',
  };
  const labelStyle = {
    display: 'block', fontSize: '0.78rem', fontWeight: '700',
    color: '#555', textTransform: 'uppercase', letterSpacing: '0.05em',
    marginBottom: '0.3rem',
  };
  const sectionHead = {
    fontSize: '0.72rem', fontWeight: '800', color: '#888',
    textTransform: 'uppercase', letterSpacing: '0.08em',
    marginBottom: '0.75rem', marginTop: '1.75rem',
    paddingBottom: '0.4rem', borderBottom: '1px solid #eee',
  };
  const col2 = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem 1.25rem' };
  const col3 = { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '0.75rem 1.25rem' };

  return (
    <div className="dashboard-container">
      {/* ── LP5 Navbar ── */}
      <nav style={{ display: 'grid', gridTemplateColumns: '220px 1fr 300px', gridTemplateRows: '110px 36px', position: 'sticky', top: 0, zIndex: 1000, boxShadow: '0 2px 12px rgba(0,0,0,0.6)' }}>
        <div style={{ gridColumn: 1, gridRow: '1 / 3', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F41238', cursor: 'pointer' }} onClick={() => navigate('/')}>
          <img src={orangeLogo} alt="PubSilo" style={{ height: '90%', maxWidth: '210px', objectFit: 'contain' }} />
        </div>
        <div style={{ gridColumn: 2, gridRow: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#13273F' }}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ color: '#aaa', fontSize: '13px', fontFamily: 'Arial, sans-serif', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '6px' }}>PubSilo Admin</div>
            <div style={{ color: '#fff', fontSize: '28px', fontWeight: '300', fontFamily: 'Arial, sans-serif', letterSpacing: '0.04em', lineHeight: 1 }}>Add Publisher Account</div>
          </div>
        </div>
        <div style={{ gridColumn: 3, gridRow: '1 / 3', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '8px', background: '#13273F' }}>
          <div style={{ color: '#fff', fontSize: '15px', fontFamily: 'Arial, sans-serif', fontWeight: '700' }}>sctadmin73</div>
          <div style={{ color: '#aaa', fontSize: '11px', fontFamily: 'Arial, sans-serif', textTransform: 'uppercase', letterSpacing: '0.1em' }}>Admin</div>
          <button onClick={handleLogout} style={{ marginTop: '4px', padding: '6px 16px', background: 'transparent', border: '1px solid #3a3a3a', borderRadius: '5px', color: '#ccc', fontSize: '12px', fontFamily: 'Arial, sans-serif', cursor: 'pointer' }}
            onMouseEnter={e => { e.currentTarget.style.background = '#222'; e.currentTarget.style.color = '#fff'; }}
            onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#ccc'; }}>
            Log Out
          </button>
        </div>
        {/* Row 2 — back strip */}
        <div style={{ gridColumn: 2, gridRow: 2, display: 'flex', alignItems: 'center', background: '#13273F', borderBottom: '2px solid #000', paddingLeft: '1rem' }}>
          <button onClick={() => navigate('/admin')}
            style={{ padding: '0 18px', height: '100%', background: 'transparent', border: 'none', borderBottom: '2px solid transparent', color: '#aaa', fontSize: '11px', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '0.08em', fontFamily: 'Arial, sans-serif', cursor: 'pointer', marginBottom: '-2px' }}
            onMouseEnter={e => { e.currentTarget.style.color = '#fff'; e.currentTarget.style.borderBottomColor = '#F41238'; }}
            onMouseLeave={e => { e.currentTarget.style.color = '#aaa'; e.currentTarget.style.borderBottomColor = 'transparent'; }}>
            ← Admin Dashboard
          </button>
        </div>
      </nav>

      <div style={{ maxWidth: '760px', margin: '2.5rem auto', padding: '0 2rem 4rem' }}>

        {/* Success panel */}
        {created && (
          <div style={{ background: '#f0fdf4', border: '1px solid #86efac', borderRadius: '10px', padding: '1.5rem 2rem', marginBottom: '2rem' }}>
            <div style={{ fontSize: '1rem', fontWeight: '800', color: '#166534', marginBottom: '1rem' }}>
              ✅ Publisher account created successfully
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.4rem 2rem', fontSize: '0.88rem', color: '#166534' }}>
              <div><strong>Company Name:</strong> {created.company_name}</div>
              <div><strong>Username:</strong> {created.username}</div>
              <div><strong>Login Email:</strong> {created.email}</div>
              <div><strong>Hub Link ID:</strong> <code style={{ background: '#dcfce7', padding: '0.1rem 0.4rem', borderRadius: '4px' }}>{created.link_id}</code></div>
              <div><strong>Tier:</strong> {created.subscription_tier}</div>
            </div>
            <div style={{ marginTop: '1.25rem', display: 'flex', gap: '0.75rem' }}>
              <button onClick={() => setCreated(null)} style={{ padding: '0.5rem 1.25rem', background: '#0d3165', color: '#fff', border: 'none', borderRadius: '6px', fontWeight: '700', fontSize: '0.88rem', cursor: 'pointer' }}>
                Add Another
              </button>
              <button onClick={() => navigate('/admin')} style={{ padding: '0.5rem 1.25rem', background: 'transparent', color: '#0d3165', border: '1px solid #0d3165', borderRadius: '6px', fontWeight: '700', fontSize: '0.88rem', cursor: 'pointer' }}>
                Back to Dashboard
              </button>
            </div>
          </div>
        )}

        {!created && (
          <form onSubmit={handleSubmit}>

            {/* Account credentials */}
            <p style={sectionHead}>Account Credentials</p>
            <div style={col2}>
              <div>
                <label style={labelStyle}>Company Name *</label>
                <input style={inputStyle} value={form.company_name} onChange={e => set('company_name', e.target.value)} required placeholder="e.g. The Daily Gazette" />
              </div>
              <div>
                <label style={labelStyle}>Username *</label>
                <input style={inputStyle} value={form.username} onChange={e => set('username', e.target.value)} required placeholder="e.g. dailygazette" />
              </div>
              <div>
                <label style={labelStyle}>Login Email *</label>
                <input style={inputStyle} type="email" value={form.email} onChange={e => set('email', e.target.value)} required placeholder="publisher@example.com" />
              </div>
              <div>
                <label style={labelStyle}>Initial Password * (min 8 chars)</label>
                <input style={inputStyle} type="password" value={form.password} onChange={e => set('password', e.target.value)} required minLength={8} placeholder="Set a temporary password" />
              </div>
            </div>

            {/* Account settings */}
            <p style={sectionHead}>Account Settings</p>
            <div style={col2}>
              <div>
                <label style={labelStyle}>Subscription Tier</label>
                <select style={inputStyle} value={form.subscription_tier} onChange={e => set('subscription_tier', e.target.value)}>
                  <option value="base">Base ($99/mo)</option>
                  <option value="elevated">Elevated ($299/mo)</option>
                  <option value="grand">Grand ($749/mo)</option>
                </select>
              </div>
              <div>
                <label style={labelStyle}>Media Type</label>
                <select style={inputStyle} value={form.mediaType} onChange={e => set('mediaType', e.target.value)}>
                  <option value="news">News</option>
                  <option value="magazine">Magazine</option>
                  <option value="blog">Blog</option>
                  <option value="podcast">Podcast</option>
                </select>
              </div>
            </div>

            {/* Contact info */}
            <p style={sectionHead}>Contact Information</p>
            <div style={col2}>
              <div>
                <label style={labelStyle}>Contact Phone</label>
                <input style={inputStyle} value={form.contact_phone} onChange={e => set('contact_phone', e.target.value)} placeholder="(555) 000-0000" />
              </div>
              <div>
                <label style={labelStyle}>Public Contact Email</label>
                <input style={inputStyle} type="email" value={form.contact_email} onChange={e => set('contact_email', e.target.value)} placeholder="tips@example.com" />
              </div>
            </div>
            <div style={{ marginTop: '0.75rem' }}>
              <label style={labelStyle}>Mailing Address</label>
              <input style={inputStyle} value={form.contact_address} onChange={e => set('contact_address', e.target.value)} placeholder="123 Main St" />
            </div>

            {/* Location */}
            <p style={sectionHead}>Location</p>
            <div style={col3}>
              <div style={{ gridColumn: '1 / 2' }}>
                <label style={labelStyle}>City</label>
                <input style={inputStyle} value={form.city} onChange={e => set('city', e.target.value)} placeholder="Oklahoma City" />
              </div>
              <div>
                <label style={labelStyle}>State</label>
                <select style={inputStyle} value={form.state} onChange={e => set('state', e.target.value)}>
                  <option value="">— Select —</option>
                  {US_STATES.map(s => <option key={s} value={s}>{s}</option>)}
                </select>
              </div>
              <div>
                <label style={labelStyle}>Zipcode</label>
                <input style={inputStyle} value={form.zipcode} onChange={e => set('zipcode', e.target.value)} placeholder="73101" maxLength={10} />
              </div>
            </div>
            <div style={{ marginTop: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <input type="checkbox" id="isLocalOnly" checked={form.isLocalOnly} onChange={e => set('isLocalOnly', e.target.checked)} style={{ width: '16px', height: '16px', cursor: 'pointer' }} />
              <label htmlFor="isLocalOnly" style={{ ...labelStyle, marginBottom: 0, cursor: 'pointer', textTransform: 'none', fontSize: '0.85rem', letterSpacing: 0 }}>
                Local-only publisher (content surfaces in local/regional feeds only)
              </label>
            </div>

            {/* Admin auth */}
            <p style={sectionHead}>Admin Authorization</p>
            <div style={{ maxWidth: '340px' }}>
              <label style={labelStyle}>Your Admin Password *</label>
              <input style={inputStyle} type="password" value={form.admin_password} onChange={e => set('admin_password', e.target.value)} required placeholder="Confirm with your admin password" />
            </div>

            {error && (
              <div style={{ marginTop: '1.25rem', padding: '0.65rem 0.9rem', borderRadius: '6px', backgroundColor: '#fee2e2', border: '1px solid #fca5a5', color: '#991b1b', fontSize: '0.875rem' }}>
                {error}
              </div>
            )}

            <div style={{ marginTop: '1.75rem', display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
              <button type="submit" disabled={loading} style={{ padding: '0.6rem 1.75rem', background: '#0d3165', color: '#fff', border: 'none', borderRadius: '6px', fontWeight: '700', fontSize: '0.92rem', cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1 }}>
                {loading ? 'Creating…' : 'Create Publisher Account'}
              </button>
              <button type="button" onClick={() => navigate('/admin')} style={{ padding: '0.6rem 1.25rem', background: 'transparent', color: '#555', border: '1px solid #ccc', borderRadius: '6px', fontWeight: '600', fontSize: '0.88rem', cursor: 'pointer' }}>
                Cancel
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
